import { IconICP } from 'common/components/icons/inner/IconICP'
import { IIconProps } from 'common/components/icons/inner/IIconProps'
import React from 'react'

export function BellIconCP(props: IIconProps): JSX.Element {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <IconICP iconName={'bell'} {...props}/>
}
